import { getToken } from './token';
import { checkAuth } from '../actions/auth';
import { getInformationSettings } from "~/apps/shared/actions/information";
import { Features } from "~/apps/shared/consts";
import { getDepartments } from "~/apps/shared/actions/departments";

let authSettings;

export const initAuth = (store) => {
  authSettings = {
    store: store,
    waiters: [],
  };
};

export const initIfAuthorized = async (user?) => {
  // TODO: Error handling
  const dispatch = authSettings.store.dispatch;
  const informationSettings = await dispatch(getInformationSettings());
  if (informationSettings && Array.isArray(informationSettings.features)
    && informationSettings.features.includes(Features.DEPARTMENTS)) {
    await dispatch(getDepartments());
  }
};

const resolveAll = (user) => {
  for (let p of authSettings.waiters) {
    p(user);
  }

  authSettings.waiters = [];
};


const refreshAuth = () => {
  const dispatch = authSettings.store.dispatch;

  const token = getToken();

  if (token) {
    dispatch(checkAuth(token)).then((data) => {
      if (data && data.result && data.result.user) {
        const user = data.entities.users[data.result.user];
        initIfAuthorized(user).finally(() => {
          resolveAll(user);
        });
      } else {
        throw new Error('Received an empty response.');
      }
    }).catch((error) => {
      console.error(error);
      resolveAll(null);
    });
  } else {
    resolveAll(null);
  }
}


export const getCurrentUserAsync = () => {
  const state = authSettings.store.getState();

  if (!!state.shared.auth.currentUser) {
    return Promise.resolve(state.shared.auth.currentUser);
  }

  const p = new Promise((resolve, reject) => {
    authSettings.waiters.push(resolve);

    if (authSettings.waiters.length == 1) {
      refreshAuth();
    }
  });

  return p;
}
